import React, { useState } from 'react';
import { Download, File, FileSpreadsheet, FileText, X } from 'lucide-react';

/**
 * 報表導出選項組件
 * @param {Object} props
 * @param {function} props.onExport - 導出回調函數，參數為導出格式
 * @param {Array} props.formats - 可選格式，默認 ['excel', 'csv', 'pdf']
 * @param {string} props.buttonText - 按鈕文字，默認 '導出報表'
 */
const ReportExportOptions = ({
    onExport,
    formats = ['excel', 'csv', 'pdf'],
    buttonText = '導出報表'
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const formatOptions = [
        { id: 'excel', label: 'Excel', icon: FileSpreadsheet, color: 'bg-green-100 text-green-600' },
        { id: 'csv', label: 'CSV', icon: FileText, color: 'bg-blue-100 text-blue-600' },
        { id: 'pdf', label: 'PDF', icon: File, color: 'bg-red-100 text-red-600' }
    ].filter(format => formats.includes(format.id));

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleFormatClick = (format) => {
        if (onExport) {
            onExport(format);
        }
        setIsOpen(false);
    };

    return (
        <div className="relative">
            <button
                onClick={toggleDropdown}
                className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
                <Download className="w-4 h-4" />
                <span>{buttonText}</span>
            </button>

            {isOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10 border border-gray-200">
                    <div className="flex justify-between items-center px-4 py-2 border-b border-gray-100">
                        <span className="text-sm font-medium">選擇格式</span>
                        <button
                            onClick={() => setIsOpen(false)}
                            className="text-gray-400 hover:text-gray-500"
                        >
                            <X className="w-4 h-4" />
                        </button>
                    </div>

                    <div className="py-2">
                        {formatOptions.map(format => (
                            <button
                                key={format.id}
                                className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                onClick={() => handleFormatClick(format.id)}
                            >
                                <div className={`p-1 rounded-md mr-3 ${format.color}`}>
                                    <format.icon className="w-4 h-4" />
                                </div>
                                <span>{format.label} 格式</span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ReportExportOptions;